import { c as _c } from "react/compiler-runtime";
import { KlaraAvatar } from "@/components/chat/KlaraAvatar";
import { DismissButton } from "@/components/chat/DismissButton";
interface InvitationCardProps {
  position: string;
  title: string;
  body: string;
  ctaLabel: string;
  dismissLabel: string;
  onOpen: () => void;
  onDismiss: (e: React.MouseEvent) => void;
}

/**
 * Invitation card shown on non-form pages for first-time visitors.
 *
 * Shows a persuasive card until the user engages (opens chat or dismisses).
 */
export function InvitationCard(t0) {
  const $ = _c(22);
  const {
    position,
    title,
    body,
    ctaLabel,
    dismissLabel,
    onOpen,
    onDismiss
  } = t0;
  const t1 = `fixed ${position} z-[60] cursor-pointer
        animate-in slide-in-from-bottom-6 fade-in duration-700
        transition-[bottom] ease-in-out`;
  let t2;
  if ($[0] !== dismissLabel || $[1] !== onDismiss) {
    t2 = <DismissButton onClick={onDismiss} label={dismissLabel} />;
    $[0] = dismissLabel;
    $[1] = onDismiss;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="border-2 border-secondary-fixed/30 p-0.5 rounded-[9999px]"><KlaraAvatar /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== title) {
    t4 = <p className="text-[15px] font-extrabold leading-snug tracking-tight">{title}</p>;
    $[4] = title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== body) {
    t5 = <p className="text-xs text-[#d5e8d2]/80 mt-1 leading-relaxed">{body}</p>;
    $[6] = body;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== ctaLabel) {
    t6 = <span className="inline-block mt-3 text-sm font-extrabold bg-white text-primary-container rounded-full px-4 py-2 transition-colors active:scale-95">{ctaLabel} →</span>;
    $[8] = ctaLabel;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <div className="flex items-start gap-3">{t3}<div>{t4}{t5}{t6}</div></div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t7) {
    t8 = <div className="group relative text-white rounded-2xl px-6 py-5 max-w-[300px] glass-dark chat-widget-hover">{t2}{t7}</div>;
    $[14] = t2;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== onOpen || $[18] !== t1 || $[19] !== t8 || $[20] !== title) {
    t9 = <div onClick={onOpen} role="complementary" aria-label={title} className={t1}>{t8}</div>;
    $[17] = onOpen;
    $[18] = t1;
    $[19] = t8;
    $[20] = title;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}